<template>
  <TrainingStep />
</template>

<script>
import TrainingStep from '@/components/content/education/training/TrainingStep.vue'

export default {
  name: 'GroupTrainingStepPage',
  components: { TrainingStep }
}
</script>

<style scoped>

</style>
